import { render, staticRenderFns } from "./MollieStep2.vue?vue&type=template&id=5efdc821&scoped=true"
import script from "./MollieStep2.vue?vue&type=script&lang=js"
export * from "./MollieStep2.vue?vue&type=script&lang=js"
import style0 from "./MollieStep2.vue?vue&type=style&index=0&id=5efdc821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdc821",
  null
  
)

export default component.exports